export default __webpack_public_path__ + "static/pro@768_2x-5da830c01cf5faf725054de94fe149f8.png";